module.exports = __webpack_public_path__ + "static/media/master_product_02.37e8de40.gif";